import React, { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import "./PrintRentalContractSliderThreeComponent.module.scss";
import RentalContractPrintSliderThree from "../common/rentalContractPrintSliderThree/RentalContractPrintSliderThree";

interface PrintComponentProps {
  content: React.ReactNode;
}

const PrintComponent = React.forwardRef<HTMLDivElement, PrintComponentProps>(
  ({ content }, ref) => {
    const [loading, setLoading] = useState(true); // State to manage loading state

    useEffect(() => {
      // Simulate loading time with a timeout
      const timeoutId = setTimeout(() => {
        setLoading(false);
      }, 1000); // Set the timeout duration as needed

      return () => clearTimeout(timeoutId); // Cleanup on component unmount
    }, []);

    if (loading) {
      return (
        <div className="flex items-center justify-center mt-80">
          <PropagateLoader color="#4A90E2" size={15} />
        </div>
      );
    }

    return (
      <div ref={ref}>
        <RentalContractPrintSliderThree />
      </div>
    );
  }
);

export default PrintComponent;
